export default __webpack_public_path__ + "static/media/Pulses.55b01d75.jpg";